import React from 'react'

const Boarding = () => {
  return (
    <div className='m-4 sm:m-8'>
      <h1 className='text-center font-semibold text-2xl sm:text-3xl underline'>Boarding Services</h1>
      <div className='flex flex-col sm:flex-row items-center mx-4 sm:mx-32 my-8'>
        <img src="/assets/dog14.jpg" alt="" className='w-40 h-40 sm:w-60 sm:h-60 mx-auto sm:mx-0'/>
        <div className='mx-4 sm:mx-8 mt-4 sm:mt-0 text-center sm:text-left'>
          <h1 className='text-lg sm:text-xl font-semibold my-2'>Kennels and Cattery for Holiday Boarding</h1>
          <p className='text-gray-700 text-sm sm:text-base'>Sometimes, you may need to leave your pets at home while traveling for a holiday or business trip, and their safety and well-being become your top concern. Akoi Foundation provides a home away from home for your pets during your travels. At Akoi, we create a relaxed and comfortable environment where your pets can enjoy their stay. We ensure they have a delightful holiday experience with ample exercise and mental stimulation. <br /> <br />
          When you board your pet with Akoi Foundation, you can be confident that your pet receives the best care possible.
          </p>
        </div>
      </div>
      <div className='m-4 sm:m-8 my-8 sm:my-16'>
        <h1 className='text-lg sm:text-xl font-semibold my-4'>Some key Features are as follows:</h1>
        <ul className='text-gray-500 mx-4 sm:mx-8 list-disc pl-4'>
          <li>Air-conditioned kennels /Cattery.</li>
          <li>Attentive staff to ensure that kennels and exercise areas are clean and comfortable.</li>
          <li>Pets are monitored very carefully during their stay by our staff for their overall well-being.</li>
          <li>Pets are fed fresh food. If the pet is on packaged food, the owner shall provide the food.</li>
          <li>Dogs are exercised four times a day.</li>
          <li>Cats are provided a separate area for boarding with all the above-mentioned facilities.</li>
        </ul>
      </div>
      <div className='border mx-16 my-8'>
        <h1 className='font-semibold text-xl text-center my-4'>NOTE</h1>
        <p className='mx-2 text-lg text-gray-700'>Akoi Foundation reserves the right to decline any boarding requests. We do not accommodate puppies or kittens younger than 4 months . We encourage pet owners to visit our facility beforehand to familiarize themselves with our boarding arrangements. Boarding requests should be made at least two weeks in advance. 
          Please bring your pet’s vaccination record to verify that all vaccinations are up to date.
          Please also let us know if your pet has any allergies.</p>
      </div>
      <div className="mx-4 sm:mx-16 my-8 shadow-lg p-6 sm:p-8 text-center bg-white rounded-md">
        <h1 className="text-2xl sm:text-3xl font-bold">Contact Us</h1>
        <div className="flex flex-col items-center mt-6 sm:mt-8">
          <a
            href="tel:9354623839"
            className="font-semibold text-lg sm:text-xl flex items-center justify-center my-4 text-blue-600 hover:text-blue-500"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/9968/9968669.png"
              alt="Call"
              className="h-12 w-12 sm:h-16 sm:w-16 mx-2 sm:mx-4"
            />
            +91 9354623839
          </a>
        </div>
        <strong>Disclaimer <p>All payments boarding will go to towards financing our shelter.</p></strong>
      </div>
    </div>
  )
}

export default Boarding;
